export default {
    roomSetting: (state, getters, rootState, rootGetters) => {
        return rootGetters['room/getRoomInfoModule'](state.roomInfoModuleName)
    },
    params: (state) => {
        return state.params
    }
}